module.exports = __webpack_public_path__ + "static/fragilite-economique2-304d747c6e0f5fe45b516244e81f5e38.svg";